module.exports = __webpack_public_path__ + "img/expectation.71f28bdb.svg";